'use strict';

import angular from 'angular';

class ClientFilterController {
    /* @ngInject */
    constructor(
        ClientsService
    ) {
        Object.assign(this, {
            ClientsService
        });
    }

    $onInit() {
    }

    update() {
        let where = {};
        let constraints = [
            ...(this.lastName ? [{
                lastName : {
                    ilike: `%${this.lastName}%`
                }   
            }] : []),
            ...(this.name ? [{
                name: {
                    ilike: `%${this.name}%`
                }
            }] : []),
            ...(this.dni ? [{
                dni: this.dni
            }] : []),
            ...(this.cuit ? [{
                cuit: this.cuit
            }] : [])
        ];
        if (constraints.length > 1) {
            where.and = constraints;
        } else if (constraints.length == 1){
            Object.assign(where, constraints[0]);
        } else {
            return this.onUpdate({
                $event: {
                    clientsPromise: Promise.resolve(null),
                    clientsConstraint: null
                }
            });
        }

        let clientsPromise = this.ClientsService.find({
            filter: {
                where: where,
                order: 'lastName ASC'
            }
        });

        this.onUpdate({
            $event: {
                clientsPromise: clientsPromise
            }
        });
    }
}

export default ClientFilterController;
